import {
  Breadcrumb,
  Button,
  Input,
  message,
  PageHeader,
  Form,
  Row,
  Col,
  Select,
} from "antd";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Page from "_components/Page";
import { machineService, machineTypesService } from "_services";

function Add({ history, match }) {
  const [isLoading, setIsLoading] = useState(false);
  const [form] = Form.useForm();
  const { Option } = Select;
  const [type, setType] = useState([]);

  useEffect(() => {
    getTypes();
  }, []);

  const getTypes = () => {
    machineTypesService
      .getSuggestion()
      .then((x) => {
        setType(x.content);
      })
      .catch((errorInfo) => {
        message.error(`${errorInfo}`);
      });
  };

  const handleFormSumbit = () => {
    form
      .validateFields()
      .then((values) => {
        setIsLoading(true);
        machineService
          .create(values)
          .then(() => {
            message.success("Successfully created!");
            setIsLoading(false);
            history.push(".");
          })
          .catch((error) => {
            setIsLoading(false);
            message.error(`${error}`);
          });
      })
      .catch((error) => {
        //message.error(`${error}`);
      });
  };

  const onCancel = () => {
    history.push(".");
  };

  
  return (
    <div>
      <PageHeader
        title={
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/dashboard">Dashboard</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to="/machines">Machine Search</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to="/machines/add">New Machine</Link>
            </Breadcrumb.Item>
          </Breadcrumb>
        }
        extra={[
          <Button
            key="1"
            htmlType="submit"
            loading={isLoading}
            onClick={handleFormSumbit}
          >
            Save
          </Button>,
          <Button key="2" htmlType="button" onClick={onCancel}>
            Cancel
          </Button>,
        ]}
      >
        <Page inner>
          <Form
            form={form}
            name="form-create"
            layout="vertical"
            requiredMark={false}
          >
            <Row gutter={24}>
              <Col span={6}>
                <Form.Item
                  name="code"
                  label="Machine Code"
                  rules={[
                    { required: true, message: "Code is required" },
                  ]}
                >
                  <Input placeholder="Machine Code" />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  name="name"
                  label="Machine Name"
                  rules={[{ required: true, message: "Name is required" }]}
                >
                  <Input placeholder="Machine Name" />
                </Form.Item>
              </Col>
              <Col span={6}>
                  <Form.Item
                    name={["type", "id"]}
                    label="Machine Type"
                    rules={[
                      {
                        required: true,
                        message: "Machine Type is required",
                      },
                    ]}
                  >
                    <Select
                      placeholder="Please select"
                      allowClear
                    >
                      {type.map((t) => (
                        <Option value={t.id} key={t.id}>
                          {t.name}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              <Col span={6}></Col>
            </Row>
          </Form>
        </Page>
      </PageHeader>
    </div>
  );
}

export default Add;
